import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_CART_TEMPLATE = gql`
    mutation CreateOrUpdateCartTemplate($data: CartTemplateInput!) {
        createOrUpdateCartTemplate(data: $data) {
            accountId
        }
    }
`;
